import {connect} from 'react-redux';

import {getIsUserGlobalAdmin} from '../../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {AddAccountCustomFieldTask} from './addAccountCustomFieldTask';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isUserGlobalAdmin: getIsUserGlobalAdmin,
}));

const mapDispatchToProps = makeMapDispatchToProps()(() => ({
  navigateToLink: navigateToLinkAction,
}));

export const AddAccountCustomFieldTaskContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddAccountCustomFieldTask);
